export default __webpack_public_path__ + "static/media/image1.3e9448d4.svg";